export const envIsElectron =
  typeof window !== 'undefined' && typeof window.electron !== 'undefined';

export const envIsTesting = process.env.NODE_ENV === 'test';
